import { message } from 'antd';
import axios from 'axios';

import { extractUrlParams } from '../../CommonFuctions/Utils';
import { DOCCHAT_ROOT_URL } from '../../config';
import { CLEAR, ERROR, LOADING, SUCCESS } from '../../Constants/commonConstants';
import { getValidAccessToken } from '../../utils/authUtils';
import {
  CLEAR_MESSAGE,
  FEEDBACK_SENT,
  GET_SAVED_DOCCHAT_HISTORY,
  SET_MESSAGE,
  UPLOAD_DOCUMENT,
} from './docChatTypes';

export function uploadDocument({ formData, loading, collection_id, presetId }) {
  return async (dispatch) => {
    if (loading) {
      dispatch({
        type: UPLOAD_DOCUMENT,
        uploadStatus: CLEAR,
      });
    } else {
      dispatch({
        type: UPLOAD_DOCUMENT,
        uploadStatus: LOADING,
      });
      try {
        let response = {};
        if (collection_id) {
          response = await axios.post(
            `${DOCCHAT_ROOT_URL}/api/collections/${collection_id}/add_document/`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${await getValidAccessToken()}`,
                'Content-Type': 'multipart/form-data',
              },
            }
          );
        } else {
          response = await axios.post(`${DOCCHAT_ROOT_URL}/api/documents/upload/`, formData, {
            headers: {
              Authorization: `Bearer ${await getValidAccessToken()}`,
              'Content-Type': 'multipart/form-data',
            },
          });
        }

        console.info('response.data.failed_documents', response.data.failed_documents);

        dispatch({
          type: UPLOAD_DOCUMENT,
          uploadStatus: SUCCESS,
          failedDocuments: response.data.failed_documents,
          // failedDocuments: [
          //   {
          //     "documentID": '1',
          //     "document_name": 'hello.docx',
          //     "failed_link": '',
          //     "error": 'error'
          //   },
          //   {
          //     "documentID": '2',
          //     "document_name": 'hello2.pdf',
          //     "failed_link": '',
          //     "error": 'error'
          //   },
          // ],
          uploadFile: {
            message: response.data.message,
            documentId: response.data.documentID,
            document_link: response.data.document_link,
            document_name: response.data.document_name,
            collection_id: response.data.collection_id,
            collection_name: response.data.collection_name,
            documents: response.data.documents,
            presetId,
          },
        });
      } catch (e) {
        dispatch({
          type: UPLOAD_DOCUMENT,
          uploadStatus: ERROR,
          uploadFile: {
            message: 'Document upload failed.',
          },
        });
      }
    }
  };
}

export function getChatHistory({ userId, loading }) {
  return async (dispatch) => {
    dispatch({
      type: GET_SAVED_DOCCHAT_HISTORY,
      savedDocChatRecordStatus: LOADING,
    });
    if (!loading) {
      try {
        let response = {};
        response = await axios.get(`${DOCCHAT_ROOT_URL}/api/chat/user/${userId}/history/`, {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        });

        dispatch({
          type: GET_SAVED_DOCCHAT_HISTORY,
          records: response.data?.history,
          savedDocChatRecordStatus: SUCCESS,
          remainingQuota: response.data?.remaining_quota,
        });
      } catch (e) {
        dispatch({
          type: GET_SAVED_DOCCHAT_HISTORY,
          savedDocChatRecordStatus: ERROR,
        });
      }
    }
  };
}

export async function deleteFile({ documentId, collectionId, title }) {
  try {
    await axios
      .delete(
        `${DOCCHAT_ROOT_URL}/api/${documentId ? 'documents' : 'collections'}/${documentId ?? collectionId}/`,
        { headers: { Authorization: `Bearer ${await getValidAccessToken()}` } }
      )
      .then(() => {
        message.success(
          `${collectionId ? 'Collection' : 'Document'} "${title}" has deleted successfully`
        );
      });
  } catch (e) {
    console.error(e);
  }
}

export async function addDocuments({ formData, collectionId }) {
  const res = await axios.post(
    `${DOCCHAT_ROOT_URL}/api/collections/${collectionId}/add_document/`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${await getValidAccessToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return res;
}

export async function renameFile({ documentId, newName, collectionId, oldName }) {
  try {
    await axios
      .put(
        `${DOCCHAT_ROOT_URL}/api/${documentId ? 'documents' : 'collections'}/${documentId ?? collectionId}/rename/`,
        { new_name: newName },
        {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
            'Content-Type': 'application/json',
          },
        }
      )
      .then(() => {
        message.success(
          `${collectionId ? 'Collection' : 'Document'} "${oldName}" has been renamed to "${newName}" successfully`
        );
      });
  } catch (e) {
    console.error(e);
  }
}

export function deleteChat({ documentId, collection_id }) {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_MESSAGE,
      documentId,
      collection_id,
    });
    try {
      let response = {};
      if (collection_id) {
        response = await axios.post(
          `${DOCCHAT_ROOT_URL}/api/collections/${collection_id}/clear_chat/`,
          {},
          {
            headers: { Authorization: `Bearer ${await getValidAccessToken()}` },
          }
        );
      } else {
        response = await axios.delete(
          `${DOCCHAT_ROOT_URL}/api/documents/delete_chat/${documentId}/`,
          {
            headers: { Authorization: `Bearer ${await getValidAccessToken()}` },
          }
        );
      }
      dispatch({
        type: CLEAR_MESSAGE,
        chat_id: response.data.chat_id || response.data.new_chat_id,
        documentId,
        collection_id,
      });
    } catch (e) {
      message.error('Try after sometime.');
    }
  };
}

export function sendFeedback({ query_response_id, feedback, documentId, collection_id }) {
  return async (dispatch) => {
    try {
      await axios.post(
        `${DOCCHAT_ROOT_URL}/api/chat/feedback/`,
        { query_response_id, feedback },
        {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch({
        type: FEEDBACK_SENT,
        query_response_id,
        documentId,
        feedback,
        collection_id,
      });
      message.success('Thank you for the feedback.');
    } catch (e) {
      console.error(e);
      message.error('Feedback is already submitted or Try after sometime.');
    }
  };
}

export function setNewMessage({
  timestamp,
  content,
  role,
  documentId,
  chat_id,
  query_response_id,
  collectionID,
  download_url,
  content_length,
}) {
  return (dispatch) => {
    try {
      dispatch({
        type: SET_MESSAGE,
        timestamp,
        content,
        role,
        documentId,
        chat_id,
        query_response_id,
        collection_id: collectionID,
        download_url,
        content_length,
      });
    } catch (e) {
      message.error('Try after sometime.');
    }
  };
}

export async function removeFromFolder({
  collectionId,
  documentId,
  pathname,
  navigate,
  userId,
  dispatch,
}) {
  const payload = { document_id: documentId, userID: userId };
  await axios
    .post(`${DOCCHAT_ROOT_URL}/api/collections/${collectionId}/remove_document/`, payload, {
      headers: {
        Authorization: `Bearer ${await getValidAccessToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(() => {
      if (pathname === '/viewer-docchat' && extractUrlParams('uuid') === collectionId) {
        navigate('/docchat');
      }
    });
  dispatch(getChatHistory({ userId }));
}

export async function moveToFolder({
  collectionId,
  documentId,
  userId,
  dispatch,
  pathname,
  navigate,
}) {
  const formData = new FormData();
  formData.append('document_ids', documentId);
  formData.append('userID', userId);
  const res = await addDocuments({ formData, collectionId });
  if (res.data?.message) {
    message.success(res.data.message);
    if (pathname === '/viewer-docchat' && extractUrlParams('uuid') === documentId) {
      navigate('/docchat');
    }
  }
  dispatch(getChatHistory({ userId }));
}

export const handleMoveToFolder = async ({
  collectionName,
  documentId,
  setLoader,
  closeModal,
  userId,
  dispatch,
  pathname,
  navigate,
}) => {
  setLoader('MOVE_TO_NEW_FOLDER');
  // const collectionId = modalData.data?.collectionId;
  try {
    const payload = { collection_name: collectionName, userID: userId };
    const collectionRes = await axios.post(`${DOCCHAT_ROOT_URL}/api/collections/`, payload, {
      headers: {
        Authorization: `Bearer ${await getValidAccessToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    if (collectionRes.data?.collection_id) {
      moveToFolder({
        collectionId: collectionRes.data.collection_id,
        documentId,
        userId,
        dispatch,
        pathname,
        navigate,
      });
    }
  } catch (error) {
    message.error('Something went wrong!. Please try again');
    console.error(error);
  } finally {
    setLoader(null);
    closeModal();
  }
};
